<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit">
        <button class="btn" type="submit" name="note_order_settings"
          @click="submit"
        >決定
        </button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">閲覧履歴の削除</span>
        </div>
        <div class="popup-content">
          <p class="txt">この閲覧履歴を削除してもよろしいですか？</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({

  setup (props, context) {
    const store = context.root.$store
    const { browsingHistory } = store.state

    const close = () => {
      context.emit('closeDeleteConfirm')
    }
    const submit = async() => {
      const params = {
        id: browsingHistory.currentId
      }
      await store
        .dispatch('browsingHistory/delete', params)
        .then(() => {
          store.dispatch('common/showToast', {
            text: '閲覧履歴を削除しました'
          })
        })
      context.emit('closeDeleteConfirm')
    }
    
    return {
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    padding: 20px;
  }
}
</style>
